import { BuybackSettings } from "@/apps/shared/buyback/core/domain/model/settings/BuybackSettings";
import { BuybackSettingsRepositoryInterface } from "@/apps/shared/buyback/core/domain/service/interface/BuybackSettingsRepositoryInterface";

class DashboardBuybackSettingsRepository implements BuybackSettingsRepositoryInterface {
  async get(): Promise<BuybackSettings> {
    return new BuybackSettings(true, 0);
  }
}

export default new DashboardBuybackSettingsRepository();
